<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="'SKU'">
            <el-input v-model="formData.amzSkuNo" readonly size="mini">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item :label="$l('table_label_goodsName') || '产品名称'">
            <el-input v-model="formData.goodsName" readonly size="mini">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_goods_name_en') ||
                '产品英文名称'
            "
          >
            <el-input v-model="formData.goodsNameEn" readonly size="mini">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="'BRAND'">
            <el-input v-model="formData.brandName" readonly size="mini">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="'CATEGORY'">
            <el-input
              v-model="formData.masterCategoryName"
              readonly
              size="mini"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="'SIZE'">
            <el-input v-model="formData.goodsSize" readonly size="mini">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="'COLOR'">
            <el-input v-model="formData.goodsColor" readonly size="mini">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="!moqMaterialDisabled">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_moq') || '起订量'">
            <el-input-number
              controls-position="right"
              style="width: 100%"
              size="mini"
              :min="0"
              :max="999999.9"
              :step="0.01"
              :precision="4"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.moq"
              v-el-inputnumber-default0
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <Table
      v-if="moqMaterialDisabled"
      :disabled="disabled"
      :amzSkuCode="amzSkuCode"
      :amzMoqCode="amzMoqCode"
    />
  </div>
</template>

<script>
import Table from './table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {
    Table,
  },
  props: {
    moqMaterialDisabled: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    amzSkuCode: { type: String, default: '' },
    amzMoqCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { usageQty: 0, moq: 0 },
      tableData: {},
      rules: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.amzSkuCode) return
      this.loadingOpen()
      this.$api
        .ecomAmzSkuDetailApi({
          amzSkuCode: this.amzSkuCode,
        })
        .then((res) => {
          this.formData = res.body
          this.$api
            .ecomAmzSkuMoqMaterialListApi({
              amzSkuCode: this.amzSkuCode,
              amzMoqCode: this.amzMoqCode,
            })
            .then((res) => {
              this.tableData = res.body.data
              if (this.tableData && this.tableData.length > 0) {
                this.formData.usageQty = this.tableData[0].usageQty
                this.formData.moq = this.tableData[0].moq
              }
              this.loadingClose()
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    save() {
      this.$api
        .ecomAmzSkuMoqMaterialUpdateApi({
          ...this.tableData[0],
          usageQty: this.formData.usageQty,
          moq: this.formData.moq,
          moqMaterialDisabled: this.moqMaterialDisabled,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.getData()
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
